import { render, staticRenderFns } from "./UploadFile.vue?vue&type=template&id=edfa1d3e&scoped=true&"
import script from "./UploadFile.vue?vue&type=script&lang=ts&"
export * from "./UploadFile.vue?vue&type=script&lang=ts&"
import style0 from "./UploadFile.vue?vue&type=style&index=0&id=edfa1d3e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edfa1d3e",
  null
  
)

export default component.exports